import { css } from '@linaria/core';
export const noRecord = "omponents__Table__NoRecord__NoRecords_styles_tsx-noRecord-n1bpy4ge";

require("./NoRecords.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./NoRecords.styles.tsx");